import React from 'react';
import { Link } from 'react-router-dom';

export default {
  displaySize: 5,
  pageSize: 15,
  pipelineMoreInfoMessage: <p>For more information, please see the <Link to="/portal/pipeline">Pipeline</Link> page.</p>
};
